<template>
 <div>

     <v-container class="fill-height" fluid>
         <v-tabs class=""  v-model="tab" v-show="!verifyPasswordDialog">
             <v-tabs-slider></v-tabs-slider>
             <v-tab :href="`#tab-${index}`" class="text-capitalize" :key="index" v-for="(tab,index) in tabs">{{tab.name}}</v-tab>
             <v-tab-item :key="index" :value="`tab-${index}`" v-for="(tab,index) in tabs">
                 <component :is="tab.component"/>
             </v-tab-item>
         </v-tabs>
     </v-container>

     <verify-password-popup :dialog.sync="verifyPasswordDialog"/>
 </div>
</template>

<script>
import AllProducts from "./AllProducts";
import RecentProducts from "./RecentProducts";
import NewProducts from "./NewProducts";
import ProfitLossReport from "../Reports/ProfitLossReport";
import VerifyPasswordPopup from "../Security/VerifyPasswordPopup";
import Vendors from "./Vendors/Vendors";
import PurchaseRequest from "./PurchaseRequest/PurchaseRequest";
export default {
    name: "Purchase",
    components: {
        PurchaseRequest,
        Vendors, VerifyPasswordPopup, NewProducts, RecentProducts, AllProducts, ProfitLossReport},
    data () {
        return {
            tab: 'tab-0',
            tabs: [
                { name: 'New Products', component: NewProducts },
                /*{ name: 'Recent Stock Products', component: RecentProducts },
                { name: 'All Products', component: AllProducts },
                /*{ name: 'Profit/Loss Report', component: ProfitLossReport },
                { name: 'Vendors', component: Vendors },
                { name: 'Purchase Request', component: PurchaseRequest },*/
            ],
            verifyPasswordDialog: true
        }
    },
}
</script>

<style scoped>
/deep/.theme--light.v-tabs>.v-tabs-bar{
    border-bottom: 1px solid #BEBEBE;
    margin-bottom: 8px;
}
</style>